import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive()
export abstract class BaseFiltersComponent<TFiltersModel> {
    @Input()
    public areFiltersOpened: boolean;

    @Output()
    public closed = new EventEmitter();

    @Output()
    public ready = new EventEmitter();

    @Output()
    public selectionChanged = new EventEmitter();

    public closeFilters(): void {
        this.areFiltersOpened = false;
        this.closed.emit();
    }

    public abstract setSelectedFilters(filters: TFiltersModel): void;
    public abstract extractSelectedFilters(): TFiltersModel;

    @HostListener('window:scroll')
    scrollHandler() {
        this.manageFiltersScrolling();
    }

    private manageFiltersScrolling() {
        const topbar = document.querySelector<HTMLElement>('.top-bar');
        const topbarHeight = topbar ? topbar.offsetHeight : 0;

        const footer = document.querySelector<HTMLElement>('.footer');
        const footerHeight = footer ? footer.offsetHeight : 0;

        const visibleAreaHeight = document.body.offsetHeight - topbarHeight - footerHeight;

        const filters = document.querySelector<HTMLElement>('.main-card-filters');
        const filtersHeight = filters ? filters.offsetHeight : 0;
        const filtersWidth = filters ? filters.offsetWidth : 0;

        const content = document.getElementById('content-list') as HTMLElement;
        const contentHeight = content ? content.offsetHeight : 0;

        /*
         * Filters positioning:
         * - Sticky top when filters component height exceed visible area height ;
         * - Fixed bottom when scroll reach filters component block's end.
         *
         * Additionally manage the content height (results list) to not fix filters when content is smaller than filters.
         */
        if (filters) {
            if (filtersHeight > visibleAreaHeight) {
                filters.classList.remove('top');

                if (window.scrollY + visibleAreaHeight >= filtersHeight + topbarHeight && contentHeight > filtersHeight) {
                    filters.classList.add('bottom');
                    filters.style.width = `${filtersWidth}px`;
                } else {
                    filters.classList.remove('bottom');
                    filters.removeAttribute('style');
                }
            } else {
                filters.classList.remove('bottom');
                filters.classList.add('top');
            }
        }

        /*
         * Content positioning:
         * - Sticky top when content is smaller than visible area (to maximize visibility of list).
         */
        if (contentHeight > visibleAreaHeight) {
            content.classList.remove('top');
        } else {
            content.classList.add('top');
        }
    }
}
